import translate from '~/zf/frontend/common/localization/translate';
import ColumnId from '../const/ColumnId';
import cellClassRules from '../../../common/ag-grid/cellRenderer/cellClassRules';
import headerTemplateWithPrecedingAlarmIcon from './headerTemplateWithPrecedingAlarmIcon';

export default function getColumnsDefinition() {
  return [
    {
      headerName: '',
      field: 'STATUS',
      lockPosition: true,
      colId: ColumnId.STATUS,
      minWidth: 50,
      maxWidth: 50,
      sortable: false,
      cellRenderer: 'StatusIcons',
    },
    {
      headerName: translate('common.TX_PLANT'),
      headerTooltip: translate('common.TX_PLANT'),
      field: 'bezeichnung',
      colId: ColumnId.bezeichnung,
      cellRenderer: 'System',
      lockPosition: true,
      minWidth: 200,
      resizable: true,
      suppressSizeToFit: true,
    },
    {
      headerName: translate('performanceOverview.POWER_PEAK'),
      headerTooltip: translate('performanceOverview.POWER_PEAK'),
      field: 'LEISTUNG',
      cellClass: 'text-right',
      colId: ColumnId.LEISTUNG,
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.YIELD'),
      headerTooltip: translate('performanceOverview.YIELD'),
      field: 'E_Z_EVU',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.E_Z_EVU,
      minWidth: 185,
      cellRenderer: 'SparklineChartYield',
    },
    {
      headerName: translate('performanceOverview.IRRADIANCE'),
      headerTooltip: translate('performanceOverview.IRRADIANCE'),
      field: 'G_M',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.G_M,
      minWidth: 185,
      cellRenderer: 'SparklineChartIrradiation',
    },
    {
      headerName: translate('performanceOverview.IRRADIANCE_SATELLITE'),
      headerTooltip: translate('performanceOverview.IRRADIANCE_SATELLITE'),
      field: 'G_M_SAT',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.G_M_SAT,
      minWidth: 185,
      cellRenderer: 'SparklineChartIrradiationSatellite',
    },
    {
      headerName: translate('performanceOverview.SPECIFIC_YIELD'),
      headerTooltip: translate('performanceOverview.SPECIFIC_YIELD'),
      field: 'E_N',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.E_N,
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.PR'),
      headerTooltip: translate('performanceOverview.PR'),
      field: 'PR',
      cellClassRules: cellClassRules.CENTER_IF_NULL,
      colId: ColumnId.PR,
      cellRenderer: 'PercentageBar',
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.AVAILABILITY'),
      headerTooltip: translate('performanceOverview.AVAILABILITY'),
      field: 'VFG',
      cellClassRules: cellClassRules.CENTER_IF_NULL,
      colId: ColumnId.VFG,
      cellRenderer: 'PercentageBar',
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.EPI'),
      headerTooltip: translate('performanceOverview.EPI'),
      field: 'EPI',
      cellClassRules: cellClassRules.CENTER_IF_NULL,
      colId: ColumnId.EPI,
      cellRenderer: 'PercentageBar',
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.DATA_INPUT'),
      headerTooltip: translate('performanceOverview.DATA_INPUT'),
      field: 'DATAINPUT',
      cellClassRules: cellClassRules.CENTER_IF_NULL,
      colId: ColumnId.DATAINPUT,
      cellRenderer: 'PercentageBar',
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.SIMULATION'),
      headerTooltip: translate('performanceOverview.SIMULATION'),
      field: 'E_SIM',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.E_SIM,
      minWidth: 125,
    },
    {
      headerName: translate('performanceOverview.DEVIATION_RATED_ACTUAL'),
      headerTooltip: translate('performanceOverview.DEVIATION_RATED_ACTUAL'),
      field: 'E_SIM_DIFF_PERC',
      cellClassRules: cellClassRules.CENTER_IF_NULL,
      cellRenderer: 'DeviationRatedActual',
      colId: ColumnId.E_SIM_DIFF_PERC,
      minWidth: 100,
    },
    {
      headerName: translate('portal.TX_LATEST_DATAINPUT'),
      headerTooltip: translate('portal.TX_LATEST_DATAINPUT'),
      field: 'LAST_DATAINPUT_LOCALTIME',
      colId: ColumnId.LAST_DATAINPUT_LOCALTIME,
      cellRenderer: 'LastDataInput',
      minWidth: 125,
    },
    {
      headerName: 'UTC Offset',
      field: 'LOCAL_TIMEZONE_OFFSET',
      colId: ColumnId.LOCAL_TIMEZONE_OFFSET,
      hide: true,
    },
    {
      headerName: translate('performanceOverview.SPECIFIC_YIELD_SIMULATED'),
      headerTooltip: translate('performanceOverview.SPECIFIC_YIELD_SIMULATED'),
      field: 'SPECIFIC_YIELD_SIMULATED',
      cellClassRules: cellClassRules.NUMBER,
      colId: ColumnId.SPECIFIC_YIELD_SIMULATED,
      minWidth: 125,
    },
    {
      headerComponentParams: {
        template: headerTemplateWithPrecedingAlarmIcon,
      },
      headerName: translate('javascript.TX_TODAY'),
      headerTooltip: translate('javascript.TX_TODAY'),
      field: 'alarmsToday',
      colId: ColumnId.alarmsToday,
      cellRenderer: 'AlarmCounter',
      cellRendererParams: {
        tooltipLabel: translate('performanceOverview.ALARMS_TODAY'),
      },
      minWidth: 100,
    },
    {
      headerComponentParams: {
        template: headerTemplateWithPrecedingAlarmIcon,
      },
      headerName: translate('javascript.TX_YESTERDAY'),
      headerTooltip: translate('javascript.TX_YESTERDAY'),
      field: 'alarmsYesterday',
      colId: ColumnId.alarmsYesterday,
      cellRenderer: 'AlarmCounter',
      cellRendererParams: {
        tooltipLabel: translate('performanceOverview.ALARMS_YESTERDAY'),
      },
      minWidth: 100,
    },
    {
      headerComponentParams: {
        template: headerTemplateWithPrecedingAlarmIcon,
      },
      headerName: translate('performanceOverview.LAST_SEVEN_DAYS'),
      headerTooltip: translate('performanceOverview.LAST_SEVEN_DAYS'),
      field: 'alarmsLastWeek',
      colId: ColumnId.alarmsLastWeek,
      cellRenderer: 'AlarmCounter',
      cellRendererParams: {
        tooltipLabel: translate('performanceOverview.ALARMS_LAST_SEVEN_DAYS'),
      },
      minWidth: 100,
    },
    {
      headerName: translate('performanceOverview.INVERTER_EVALUATION'),
      headerTooltip: translate('performanceOverview.INVERTER_EVALUATION'),
      field: 'INVERTER_EVALUATION',
      colId: ColumnId.INVERTER_EVALUATION,
      cellRenderer: 'InvertersBar',
      minWidth: 125,
      sortable: false,
    },
  ];
}
